module.exports = __webpack_public_path__ + "img/default_user.7ba261cb.png";